import { render, staticRenderFns } from "./ModalAlertLogin.vue?vue&type=template&id=55865e52&scoped=true&"
import script from "./ModalAlertLogin.vue?vue&type=script&lang=js&"
export * from "./ModalAlertLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55865e52",
  null
  
)

export default component.exports